export const palette = {
  accordion: {
    expanded: "#F3F3F3",
    collapse: "#F9F9F9",
  },
  primary: {
    dark: "#ffffff",
    main: "#1E1E1E",
    light: "#26DDE6",
    contrastText: "#000",
  },
  secondary: {
    dark: "#161616", // No use
    main: "#515557",
    light: "#1E1E1E",
    contrastText: "#31B4BF",
  },
  background: {
    default: "#F9F9F9", 
    paper: "#ffffff", 
  },
  info: {
    main: "#26DDE6", 
  },
  input: {
    focus: "#26DDE6", 
    border: "#DEDFDF",
    error: "#FF0000",
  },
  text: {
    secondary: "#0a0a0a", 
    disabled: "rgb(190,190,190)",
    main: "#000000",
  },
  action: {
    disabled: "rgb(190, 190, 190)",
    selected: "#000",
    active: "#333333",
    disabledBackground: "rgba(38, 221, 230, 0.3)",
  },
  border: {
    default: "#DEDFDF", 
  },
  button: {
    text: "#000000"
  },
};
